import moment from 'moment'
import { Link } from 'react-router-dom'

import styles from './InvoiceInstructions.module.scss'

const InvoiceInstructions = ({ invoiceDetails }) => {
  const { isAutoPayEnabled, autoPayChargeDate } = invoiceDetails

  return (
    <div className={styles.paymentMethods}>
      {' '}
      {isAutoPayEnabled && autoPayChargeDate && (
        <div className={styles.paymentMethodsCol}>
          <div className={styles.paymentMethodsColInner}>
            <h3 className={styles.paymentMethodsTitle}>
              Thanks for using automated payment
            </h3>
            <div className={styles.paymentMethodText}>
              <p>
                Your automatic payment on{' '}
                {moment(autoPayChargeDate).format('MMM DD, YYYY')}, includes your amount
                due, plus or minus any payment related activities or adjustments.
              </p>
            </div>
          </div>
        </div>
      )}
      <div className={styles.paymentMethodsCol}>
        <div className={styles.paymentMethodsColInner}>
          <h3 className={styles.paymentMethodsTitle}>
            Pay online <span className={styles.paymentMethodPill}>Recommended</span>{' '}
          </h3>
          <div className={styles.paymentMethodText}>
            <p>
              Go to <Link to="/billing">directful.com/pay</Link> and pay online using
              either a physical check or credit card. Save environment and save time!
            </p>
          </div>
        </div>
      </div>
      {!isAutoPayEnabled && (
        <div className={styles.paymentMethodsCol}>
          <div className={styles.paymentMethodsColInner}>
            <h3 className={styles.paymentMethodsTitle}>Pay by first-class mail</h3>
            <div className={styles.paymentMethodText}>
              <p>
                Make the check payable to SwayPay Inc. and send it to following address:
              </p>
              <p>
                SwayPay, Inc. 1259 El Camino Real, Unit #1001
                <br />
                Menlo Park, CA 94025
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default InvoiceInstructions
